import { render, staticRenderFns } from "./TagForm.vue?vue&type=template&id=6f3b14a8&scoped=true&"
import script from "./TagForm.vue?vue&type=script&lang=js&"
export * from "./TagForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b14a8",
  null
  
)

export default component.exports